import InvestmentSourceAccount from "./InvestmentSourceAccount"; 

const AccountTransactionTypes = ({ recordTypeName, transactionTypes, handleTransactionTypeId, accounts, handleSetSourceAccount }) => {

    function isBankingAndInvestmentPair(accounts) {
        if (accounts.length !== 2) return false;
        const types = accounts.map(a => a.RecordTypeName);
        return types.includes('BANKING') && types.includes('INVESTMENT');
    }

    const shouldFilterTransfer = accounts.length === 1 || isBankingAndInvestmentPair(accounts);

    if (shouldFilterTransfer) {
        transactionTypes = transactionTypes.filter(item => item.TransactionType !== 'Transfer');
    }

    return (
        <div className=" mb-4 relative z-0 w-1/2 mb-5 group mt-4 flex flex-wrap mb-4 mt-2 bg-gray-600/10 items-center mt-2 p-2 rounded-2xl hover:shadow-lg cursor-pointer">
            <h3 className="mb-2 text-gray-500 text-sm font-sm">Transaction type</h3>
            <ul className="flex flex-wrap">
                {transactionTypes
                    ?.filter(item => item.RecordTypeName === recordTypeName)
                    .map(item => (
                        <li key={item.Id} className="mx-1 my-2">
                            <label htmlFor={item.Id} className="block relative">
                                <input
                                    id={item.Id}
                                    type="radio"
                                    name="transactionType"
                                    onChange={() => handleTransactionTypeId(item.Id, item.TransactionType)}
                                    className="sr-only peer"
                                />
                                <div className="w-full p-2 cursor-pointer rounded-lg bg-gray-600 shadow-sm ring-white peer-checked:ring-1 duration-200">
                                    <h3 className="leading-none text-gray-400 font-medium text-sm" 
                                    >{item.TransactionTypeIcon} 
                                    </h3>
                                </div>
                            </label>
                        </li>
                    ))}
            </ul>
            <InvestmentSourceAccount accounts={accounts} recordTypeName={recordTypeName} handleSetSourceAccount={handleSetSourceAccount} />
        </div>
    )
}

export default AccountTransactionTypes;